<template>
  <Alert v-if="success" class="success" icon="check">
    <p>
      An E-mail has been sent to your E-mail address.
    </p>
    <p>
      Please check your E-mail for further instructions.
    </p>
  </Alert>
  <div v-else>
    <DecoratedButton :loading="loading" @click="reset">
      <small>Get an E-mail to recover access</small>
    </DecoratedButton>
    <Divider />
    <DecoratedButton class="short plain" @click="$emit('verify')">
      <small>Use Authenticator App</small>
    </DecoratedButton>
  </div>
</template>

<script>
export default {
  name: "auth-modal-two-factor-reset",
  data: function() {
    return {
      email: "",
      success: false,
      loading: false
    };
  },
  methods: {
    reset() {
      this.loading = true;
      this.services.UserResource.authCodeRemind()
        .then(() => {
          this.loading = false;
          this.success = true;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.loader-wrapper {
  display: inline-block;
}
</style>
